import React from 'react';
import FormatDate from '../date/FormatDate';
import { Typography } from '@mui/material';

const TextAuditLog = ({ updatedBy, updatedAt, createdAt, createdBy }) => {
  const audit = {
    user: updatedBy || createdBy,
    date: updatedAt || createdAt,
    action: updatedBy ? 'Updated' : 'Created'
  };

  return (
    <div>
      <Typography variant='body2' color='textSecondary'>
        {audit?.action} by {audit?.user?.code || 'System'} on
      </Typography>
      <Typography component='span' variant='body2'>
        <FormatDate date={audit?.date} pattern='dd/MMM/yyyy HH:mm a' />
      </Typography>
    </div>
  );
};

export default TextAuditLog;
